var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSkipNext48(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48 0H0v48h48z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.953 23.162 11.8 16.165a1.2 1.2 0 0 0-1.8 1.04v14.588a1.2 1.2 0 0 0 1.799 1.04l12.154-6.996v5.957a1.2 1.2 0 0 0 1.8 1.04l12.67-7.294a1.2 1.2 0 0 0 0-2.08l-12.67-7.293a1.2 1.2 0 0 0-1.8 1.04v5.955z",
    fill: "currentColor"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkipNext48);
export default __webpack_public_path__ + "static/media/skip_next_48.457c103c.svg";
export { ForwardRef as ReactComponent };